import { render, staticRenderFns } from "./AppointmentStatusChip.vue?vue&type=template&id=713459d2&scoped=true"
import script from "./AppointmentStatusChip.vue?vue&type=script&lang=ts"
export * from "./AppointmentStatusChip.vue?vue&type=script&lang=ts"
import style0 from "./AppointmentStatusChip.vue?vue&type=style&index=0&id=713459d2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "713459d2",
  null
  
)

export default component.exports